import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=d59ad686&scoped=true"
import script from "./saleDetail.vue?vue&type=script&lang=ts"
export * from "./saleDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59ad686",
  null
  
)

export default component.exports